"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateTheme = exports.ThemeDetails = exports.ThemeParameters = exports.Theme = void 0;
const swagger_proxy_1 = require("./swagger-proxy");
const class_validator_proxy_1 = require("./class-validator-proxy");
const class_transformer_proxy_1 = require("./class-transformer-proxy");
class Theme {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "The name of the theme",
        example: "Electric Era Default",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], Theme.prototype, "name", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "The revision number of the theme",
        example: 3,
        type: Number,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], Theme.prototype, "revision", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "When the theme was last updated",
        example: "2023-12-15T10:30:00.000Z",
        type: Date,
    }),
    (0, class_validator_proxy_1.IsDate)(),
    __metadata("design:type", Date)
], Theme.prototype, "updatedDate", void 0);
exports.Theme = Theme;
class ThemeParameters {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Primary brand color in hex format",
        example: "#0066CC",
        type: String,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], ThemeParameters.prototype, "brandColor", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Secondary brand color in hex format",
        example: "#FF6600",
        type: String,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], ThemeParameters.prototype, "secondaryBrandColor", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Gauge color in hex format",
        example: "#00CC66",
        type: String,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], ThemeParameters.prototype, "gaugeColor", void 0);
exports.ThemeParameters = ThemeParameters;
class ThemeDetails {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Theme styling parameters including colors",
        type: ThemeParameters,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.ValidateNested)(),
    (0, class_transformer_proxy_1.Type)(() => ThemeParameters),
    __metadata("design:type", ThemeParameters)
], ThemeDetails.prototype, "theme", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "File ID for the primary logo image",
        example: "logo-abc123.png",
        type: String,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], ThemeDetails.prototype, "primaryLogoImageFileId", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "File ID for the primary background image",
        example: "bg-def456.jpg",
        type: String,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], ThemeDetails.prototype, "primaryBackgroundImageFileId", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "File ID for the primary video content",
        example: "video-ghi789.mp4",
        type: String,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], ThemeDetails.prototype, "primaryVideoFileId", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "File ID for the primary waiting graphic",
        example: "graphic-jkl012.png",
        type: String,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], ThemeDetails.prototype, "primaryWaitingGraphicFileId", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "URL for the static experience iframe",
        example: "https://example.com/custom-experience",
        type: String,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], ThemeDetails.prototype, "staticExperienceIframeUrl", void 0);
exports.ThemeDetails = ThemeDetails;
class CreateTheme {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "The name for the new theme",
        example: "My Custom Theme",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], CreateTheme.prototype, "name", void 0);
exports.CreateTheme = CreateTheme;
